import C from "./constants";

export const changeTheme = (theme) => ({
  type: C.CHANGE_THEME,
  theme,
});

export const updateData = (key, data) => ({
  type: C.UPDATE_DATA,
  key,
  data,
});

export const updateSelections = (key, data) => ({
  type: C.UPDATE_SELECTIONS,
  key,
  data,
});

export const updateMultiSelections = (data) => ({
  type: C.UPDATE_MULTI_SELECTIONS,
  data,
});

export const updateAlertInfo = (data) => ({
  type: C.UPDATE_ALERT_INFO,
  data,
});

export const updateUserInfo = (data) => ({
  type: C.UPDATE_USER_INFO,
  data,
});

export const resetFilters = (data) => ({
  type: C.RESET_FILTERS,
});

export const updateConfigUserInputs = (key, data) => ({
  type: C.UPDATE_CONFIG_USER_INPUTS,
  key,
  data,
});

export const updateCountryRegions = (data) => ({
  type: C.UPDATE_COUNTRY_REGIONS,
  data,
});

export const emptyTestControl = () => ({
  type: C.EMPTY_TEST_CONTROL,
});

export const updateControlRegions = () => ({
  type: C.UPDATE_CONTROL_REGIONS,
});

export const updateTestRegions = () => ({
  type: C.UPDATE_TEST_REGIONS,
});

export const updateRegionsData = () => ({
  type: C.UPDATE_REGIONS_DATA,
});

export const updateWholeConfigUserInputs = (data) => ({
  type: C.UPDATE_WHOLE_CONFIG_USER_INPUTS,
  data,
});

export const toggleModel = (data) => ({
  type: C.TOGGLE_MODEL,
  data,
});

export const addDataset = (data) => ({
  type: C.ADD_DATASET,
  data,
});

export const removeDataset = (data) => ({
  type: C.REMOVE_DATASET,
  data,
});

export const addKpi = (data) => ({
  type: C.ADD_KPI,
  data,
});

export const removeKpi = (data) => ({
  type: C.REMOVE_KPI,
  data,
});

export const addMergeKpi = (data) => ({
  type: C.ADD_MERGE_KPI,
  data,
});

export const removeMergeKpi = (data) => ({
  type: C.REMOVE_MERGE_KPI,
  data,
});

export const updateDatasetLocalParameters = (data) => ({
  type: C.UPDATE_DATASET_LOCAL_PARAMETERS,
  data,
});

export const updateMergeDatasetLocalParameters = (data) => ({
  type: C.UPDATE_MERGE_DATASET_LOCAL_PARAMETERS,
  data,
});

export const updateModelLocalParameters = (data) => ({
  type: C.UPDATE_MODEL_LOCAL_PARAMETERS,
  data,
});

export const updateCategory = (data) => ({
  type: C.UPDATE_CATEGORY,
  data,
});
export const updateCategoryKpi = (data) => ({
  type: C.UPDATE_CATEGORY_KPI,
  data,
});
export const updateRunData = (data) => ({
  type: C.UPDATE_RUN_DATA,
  data,
});

// export const updateRunData = (data) => ({
//   type: C.UPDATE_RUN_DATA_V2,
//   data,
// });
export const reloadRunData = (data) => ({
  type: C.RELOAD_RUN_DATA,
});

export const updateSharedRunsData = (data) => ({
  type: C.UPDATE_SHARED_RUN_DATA,
  data,
});

export const refreshData = (data) => ({
  type: C.REFRESH_DATA,
});

export const updateDialogInfo = (data) => ({
  type: C.UPDATE_DIALOG_INFO,
  data,
});

export const reloadConfigs = () => ({
  type: C.RELOAD_CONFIGS,
});

export const toggleDataset = (data) => ({
  type: C.TOGGLE_DATASET,
  data,
});

export const toggleKpi = (data) => ({
  type: C.TOGGLE_KPI,
  data,
});

export const addToggleKpi = (data) => ({
  type: C.ADD_TOGGLE_KPI,
  data,
});

export const updateDatasetOnCountryChange = (data) => ({
  type: C.UPDATE_DATASET_ON_COUNTRY_CHANGE,
  data,
});

export const updateCategoryDataset = (data) => ({
  type: C.UPDATE_CATEGORY_DATASET,
  data,
});

export const selectAll = (data) => ({
  type: C.SELECT_ALL,
  data,
});

export const clearAll = (data) => ({
  type: C.CLEAR_ALL,
  data,
});

export const toggleSidenav = (data) => ({
  type: C.TOGGLE_SIDENAV,
});

export const refreshComments = (data) => ({
  type: C.REFRESH_COMMENTS,
});

export const updateAdminPanelUserDetails = (key, data) => ({
  type: C.UPDATE_ADMIN_PANEL_USER_DETAILS,
  key,
  data,
});

export const getUsersList = () => ({
  type: C.GET_USERS_LIST,
});

export const getADUsers = (data) => ({
  type: C.GET_AD_USERS,
  data,
});

export const getUserInfo = (preferredUsername) => ({
  type: C.GET_USER_INFO,
  data: { preferredUsername },
});

export const addUser = (data) => ({
  type: C.ADD_USER,
  data,
});

export const modifyUser = (data) => ({
  type: C.MODIFY_USER_INFO,
  data,
});

export const getGroupInfo = (groupId) => ({
  type: C.GET_GROUP_INFO,
  data: { groupId },
});

export const updateUserListFilterString = (data) => ({
  type: C.UPDATE_USER_LIST_FILTER_STRING,
  data,
});

export const updateAdminUserList = (data) => ({
  type: C.USERS_LIST_RECEIVED,
  data,
});

export const groupsInfoReceived = (data) => ({
  type: C.GROUPS_INFO_RECEIVED,
  data,
});

export const updateFeatureList = (data) => ({
  type: C.FEATURE_LIST_RECEIVED,
  data,
});

export const updateUserInfoForAdmin = (data) => ({
  type: C.UPDATE_USER_INFO_FOR_ADMIN,
  data,
});

export const reloadAdminUserList = () => ({
  type: C.RELOAD_ADMIN_USER_LIST,
});

export const resetAddEditAlert = () => ({
  type: C.RESET_ADD_EDIT_STATUS_RECEIVED,
});

export const addGroup = (data) => ({
  type: C.ADD_GROUP,
  data,
});

export const getApps = () => ({
  type: C.GET_APPS,
});

export const getCountries = (data) => ({
  type: C.GET_COUNTRIES,
  data,
});

export const getGlobalParams = (data) => ({
  type: C.GET_GLOBAL_PARAMS,
  data,
});

export const getBrands = (data) => ({
  type: C.GET_BRANDS,
  data,
});

export const getAdminGlobalParams = (data) => ({
  type: C.GET_ADMIN_GLOBAL_PARAMS,
  data,
});

export const updateKpiVariables = (data) => ({
  type: C.UPDATE_KPI_VARIABLES,
  data,
});

export const resetNewKPI = (data) => ({
  type: C.RESET_NEW_KPI,
  data,
});
export const onChangeCategory = (data) => ({
  type: C.ON_CHANGE_CATEGORY,
  data,
});
export const onChangeDERunConfig = (key, data) => ({
  type: C.ON_CHANGE_DE_CONFIG,
  key,
  data,
});

export const filterDataset = () => ({
  type: C.FILTERING_DATASET,
});

export const filterMergeDatasetForWeeks = () => ({
  type: C.FILTERING_MERGED_DATASET_FOR_WEEKS,
});

export const addMergeDataset = (data) => ({
  type: C.ADD_MERGE_DATASET,
  data,
});
export const editMergeDataset = (data) => ({
  type: C.EDIT_MERGE_DATASET,
  data,
});
export const deleteMergeDataset = (data) => ({
  type: C.DELETE_MERGE_DATASET,
  data,
});

export const selectAllForMerged = (data) => ({
  type: C.SELECT_ALL_FOR_MERGED,
  data,
});

export const clearAllForMerged = (data) => ({
  type: C.CLEAR_ALL_FOR_MERGED,
  data,
});
export const resetMergedDataset = (data) => ({
  type: C.RESET_MERGED_DATASET,
  data,
});
export const addGlobalParams = (data) => ({
  type: C.ADD_GLOBAL_PARAMS,
  data,
});
export const filterSku = (data) => ({
  type: C.FILTER_SKU,
  data,
});
export const filterKpi = (data) => ({
  type: C.FILTER_KPI,
  data,
});
export const filterMergeDataset = () => ({
  type: C.FILTERING_MERGED_DATASET,
});
export const updatePeriodicity = () => ({
  type: C.UPDATE_PERIODICITY,
});
export const addManualKpi = (data) => ({
  type: C.ADD_MANUAL_KPI,
  data,
});

export const deleteManualKpi = (data) => ({
  type: C.DELETE_MANUAL_KPI,
  data,
});
export const resetManualKpi = (data) => ({
  type: C.RESET_MANUAL_KPI,
  data,
});

export const addConfigManualKPI = (data) => ({
  type: C.ADD_CONFIG_MANUAL_KPI,
  data,
});

export const updateRunExpandInfo = (key) => ({
  type: C.UPDATE_RUN_EXPAND_INFO,
  key,
});

export const updateStatusOfCancelRun = (key, data) => ({
  type: C.UPDATE_RUN_CANCEL,
  key,
  data,
});

export const updateRunCancelStatus = (key, data) => ({
  type: C.UPDATE_RUN_STATUS,
  key,
  data,
});

export const updateModelCampaignData = (data) => ({
  type: C.UPDATE_MODEL_CAMPAIGN_DATA,
});

export const addCampaignDatasets = (key, data) => ({
  type: C.UPDATE_CAMPAIGN_DATASETS_DATA,
  key,
  data,
});

export const filterSUMediaDatasets = (data) => ({
  type: C.FILTER_SU_MEDIA_DATASETS,
  data,
});
export const updateValidationState = (data) => ({
  type: C.UPDATE_VALIDATION_STATE,
  data,
});
export const updateSalesMediaRegions = (data) => ({
  type: C.UPDATE_SALES_MEDIA_REGIONS,
  data,
});

// AIDE Console Actions
export const aideConsoleUpdateUsers = (data) => ({
  type: C.AIDE_CONSOLE_UPDATE_USERS,
  data,
});

export const aideConsoleUpdateCountryBrands = (data) => ({
  type: C.AIDE_CONSOLE_UPDATE_COUNTRY_BRANDS,
  data,
});

export const aideConsoleUpdateSearchUsers = (data) => ({
  type: C.AIDE_CONSOLE_UPDATE_SEARCH_USERS,
  data,
});

export const aideConsoleCleanSearchUsers = () => ({
  type: C.AIDE_CONSOLE_CLEAN_SEARCH_USERS,
});

export const aideConsoleUpdateUserList = (data) => ({
  type: C.AIDE_CONSOLE_UPDATE_USER_LIST,
  data,
});

export const aideConsoleReset = () => ({
  type: C.AIDE_CONSOLE_RESET,
});
